import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AuthSelectors } from '../../../../redux/auth';
import { ConfirmPopupActions } from '../../../../redux/confirmPopup';
import { SnackActions } from '../../../../redux/snackBar';
import { SupervisorsActions, SupervisorsSelectors } from '../../../../redux/supervisors';
import { formatEnumForSelector, formatRegionsSelector, userStatus } from '../../../../utils';
import { SupervisorsList } from './SupervisorsList';

const mapStateToProps = state => ({
  strings: getTranslate(state.locale),
  supervisors: SupervisorsSelectors.getSupervisors()(state),
  regions: formatRegionsSelector(
    getTranslate(state.locale),
    state.commons.regions
  ),
  statusFilter: formatEnumForSelector(getTranslate(state.locale), userStatus),
  isBoUserAdmin: AuthSelectors.isUserAdmin(state),
});

const mapDispatchToProps = dispatch => ({
  showPopup: (message, popupAction) => dispatch(ConfirmPopupActions.displayPopup(message, popupAction)),
  getSupervisors: () => dispatch(SupervisorsActions.getSupervisorsRequested()),
  setCurrentFilter: (page, filter) => dispatch(SupervisorsActions.setSupervisorsCurrentFilter(page, filter)),
  deleteSupervisor: (id) => dispatch(SupervisorsActions.deleteSupervisorRequested(id)),
  exportList: () => dispatch(SupervisorsActions.exportSupervisorsRequested()),
  navigateTo: path => dispatch(push(path)),
  setActionSnackBar: (snackAction, actionMessage) => dispatch(SnackActions.setAction(snackAction, actionMessage)),
  showSnackBar: (message) => dispatch(SnackActions.displayInfo(message)),
  hideSnackBar: () => dispatch(SnackActions.hideSnackBar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupervisorsList);
